import OnOffToggle from 'components/generics/toggles/OnOffToggle';
import { UPDATE_ACCREDITED_INVESTOR } from 'graphql/kycIdentity/mutations/updateInvestmentProfile';
import { useLandaApiMutation } from 'hooks/api/graphql/landa_api';
import { useEffect, useState } from 'react';
import { useKycStore } from 'stores/KYCIdentities/kycIdentities';

interface Props {
  isAccredited: boolean;
}

const AccreditedToggle = ({ isAccredited }: Props) => {
  const [innerIsAccredited, setInnerIsAccredited] =
    useState<boolean>(isAccredited);

  useEffect(() => {
    setInnerIsAccredited(isAccredited);
  }, [isAccredited]);

  const [editInvestmentInfo] = useLandaApiMutation(UPDATE_ACCREDITED_INVESTOR);
  const { kycIdentities, setInvestmentProfile } = useKycStore();
  const investmentProfile = kycIdentities.attributes?.investment_profile;

  const onPress = async (value: boolean) => {
    const response = await editInvestmentInfo({
      variables: { is_accredited: value },
    });
    if (response?.data?.editInvestmentInfo?.ok) {
      setInvestmentProfile({
        ...investmentProfile,
        isAccredited: value,
      });
      setInnerIsAccredited(value);
      // track(ACCREDITATION_UPDATE_SUCCESS, { from: investmentProfile?.isAccredited, to: !switchStatus });
      // firebaseAnalytics(ACCREDITATION_UPDATE_SUCCESS, { from: investmentProfile?.isAccredited, to: !switchStatus });
    }
  };

  return (
    <OnOffToggle
      isOn={innerIsAccredited}
      onChangeValue={(value) => onPress(value)}
    />
  );
};

export default AccreditedToggle;
